import { getProjectOptionsByEnvironment } from "../../../../services/mini/getProjectOptionsByEnvironment";

export function getBtnStyles(options) {
    const defaultItem = [{ id: 'default', name: 'Default style' }];

    return [
        ...defaultItem,
        ...options
    ];
}

export function getSavedOptions(props) {
    const {
        platform,
        environment,
        cohorts,
        selectedCohortId,
        project,
    } = props;
    return getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);
}

export function getSavedOptionsPerPlatform(props) {
    const { platform } = props;
    return getSavedOptions(props)[platform];
}

export function getSelectedBtnStyleId(props, mode?) {
    const { project, platform, environment, cohorts, selectedCohortId } = props;
    const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

    const selectedBtnStyleId = options?.selectedBtnOptionId || options[platform]?.selectedBtnOptionId || 'default';

    if (mode) {
        return options?.themes?.[mode]?.id || options[platform]?.themes?.[mode]?.id || selectedBtnStyleId;
    }

    return selectedBtnStyleId;
}

export function getThemeOptions(props, theme) {
    const { project, platform, environment, cohorts, selectedCohortId } = props;
    const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

    return options[platform]?.themes?.[theme]?.options || options[platform];
}